import { render } from "./TranslationPackages.vue?vue&type=template&id=53fdadf7"
import script from "./TranslationPackages.vue?vue&type=script&lang=js"
export * from "./TranslationPackages.vue?vue&type=script&lang=js"

import "./TranslationPackages.vue?vue&type=style&index=0&id=53fdadf7&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__